"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreType = void 0;
exports.StoreType = {
    Cookie: 'cookie',
    LocalStorage: 'localStorage',
    Memory: 'memory',
};
//# sourceMappingURL=types.js.map